/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBuyerProtectionBox_user = {
    readonly tradeFirm?: {
        readonly rewards: {
            readonly currentProgram: {
                readonly programInfo: {
                    readonly code: string | null;
                } | null;
                readonly childPrograms: ReadonlyArray<{
                    readonly code: string | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": "PdpSharedBuyerProtectionBox_user";
};
export type PdpSharedBuyerProtectionBox_user$data = PdpSharedBuyerProtectionBox_user;
export type PdpSharedBuyerProtectionBox_user$key = {
    readonly " $data"?: PdpSharedBuyerProtectionBox_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBuyerProtectionBox_user">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "code",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "PdpSharedBuyerProtectionBox_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tradeFirm",
          "storageKey": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "rewards",
              "storageKey": null,
              "args": null,
              "concreteType": "TradeFirmRewards",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "currentProgram",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ParentProgram",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "programInfo",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "LoyaltyProgram",
                      "plural": false,
                      "selections": (v0/*: any*/)
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "childPrograms",
                      "storageKey": "childPrograms(filter:\"ENHANCED_BUYER_PROTECTION\")",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "filter",
                          "value": "ENHANCED_BUYER_PROTECTION"
                        }
                      ],
                      "concreteType": "LoyaltyProgram",
                      "plural": true,
                      "selections": (v0/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '52e16d85248de82b0ce346054057fe89';
export default node;
